/* ==========================================================================
   TNF · Warenkorbseite
   --------------------------------------------------------------------------
   Vier Aufgaben: Menge aendern, Artikel entfernen, "Fuer spaeter merken" und
   Gutscheincode einloesen.

   Mengen und Entfernen laufen ueber /cart/change.js. Die Antwort enthaelt
   dank der Section Rendering API die frisch gerenderte Section - dadurch
   stimmen Zwischensumme, Rabattzeilen und Mehrwertsteuer sofort, ohne dass
   der Betrag hier im Browser nachgerechnet wird. Nachgerechnete Betraege
   laufen frueher oder spaeter auseinander; die Kasse rechnet ohnehin selbst.

   Ohne JavaScript bleibt die Seite bedienbar: die Mengenfelder heissen
   updates[] und liegen in einem <form> auf /cart.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'tnf-cart';
  var LATER_KEY = 'tnf-later';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function box() {
    return document.querySelector('[data-tnf-cart]');
  }

  /* --------------------------------------------------------------- Neu zeichnen
     Die Section kommt als fertiges HTML zurueck. Ersetzt wird nur der innere
     Teil, damit der aeussere Knoten mit data-tnf-cart erhalten bleibt - an ihm
     haengt die Ereignisbehandlung. */
  function repaint(html) {
    var current = box();
    if (!current || !html) {
      window.location.reload();
      return;
    }
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-tnf-cart]');
    if (!fresh) {
      window.location.reload();
      return;
    }
    current.innerHTML = fresh.innerHTML;
    document.dispatchEvent(new CustomEvent('tnf:cart-repainted'));
    paintLater();
  }

  function change(line, quantity, row) {
    if (row) row.classList.add('is-busy');

    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function (data) {
        // Halos Kopfzeile und der Drawer hoeren auf dieses Ereignis.
        document.dispatchEvent(new CustomEvent('cart-update', { detail: data }));
        repaint(data.sections && data.sections[SECTION]);
        return data;
      })
      .catch(function () {
        if (row) row.classList.remove('is-busy');
        window.location.reload();
      });
  }

  /* ------------------------------------------------------------------ Klicks */
  document.addEventListener('click', function (e) {
    var host = e.target.closest('[data-tnf-cart]');
    if (!host) return;

    var step = e.target.closest('[data-tnf-step]');
    var remove = e.target.closest('[data-tnf-remove]');
    var later = e.target.closest('[data-tnf-later]');
    var apply = e.target.closest('[data-tnf-code-apply]');
    var back = e.target.closest('[data-tnf-later-back]');
    var drop = e.target.closest('[data-tnf-later-drop]');

    if (step) {
      e.preventDefault();
      var row = step.closest('[data-tnf-line]');
      var input = row.querySelector('[data-tnf-qty]');
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.tnfStep, 10);
      if (next < 1) next = 1;
      input.value = next;
      change(parseInt(row.dataset.tnfLine, 10), next, row);
      return;
    }

    if (remove) {
      e.preventDefault();
      var rrow = remove.closest('[data-tnf-line]');
      change(parseInt(rrow.dataset.tnfLine, 10), 0, rrow);
      return;
    }

    if (later) {
      e.preventDefault();
      var lrow = later.closest('[data-tnf-line]');
      saveLater({
        id: later.dataset.variant,
        qty: parseInt(later.dataset.quantity, 10) || 1,
        title: later.dataset.title
      });
      change(parseInt(lrow.dataset.tnfLine, 10), 0, lrow);
      return;
    }

    if (back) {
      e.preventDefault();
      var id = back.dataset.tnfLaterBack;
      var entry = readLater().filter(function (x) { return String(x.id) === String(id); })[0];
      if (!entry) return;
      back.disabled = true;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(entry.id), quantity: entry.qty || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          dropLater(id);
          window.location.reload();
        })
        .catch(function () {
          back.disabled = false;
          back.textContent = 'Hat nicht geklappt';
        });
      return;
    }

    if (drop) {
      e.preventDefault();
      dropLater(drop.dataset.tnfLaterDrop);
      paintLater();
      return;
    }

    if (apply) {
      e.preventDefault();
      var field = host.querySelector('[data-tnf-code]');
      var code = (field && field.value || '').trim();
      var msg = host.querySelector('[data-tnf-code-msg]');
      if (!code) {
        if (field) field.focus();
        return;
      }
      // Shopify prueft den Code erst an der Kasse. Der Weg ueber /discount/CODE
      // hinterlegt ihn in der Sitzung; ob er greift, zeigt die Zusammenfassung
      // nach dem Neuladen.
      if (msg) {
        msg.hidden = false;
        msg.textContent = 'Code wird geprüft …';
      }
      window.location.href =
        root() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root() + 'cart');
    }
  });

  /* ------------------------------------------------------- Menge direkt tippen */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-tnf-qty]');
    if (!input) return;
    var row = input.closest('[data-tnf-line]');
    if (!row) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 0) value = 1;
    change(parseInt(row.dataset.tnfLine, 10), value, row);
  });

  /* ------------------------------------------------- Fuer spaeter gemerkt
     Die Liste liegt im localStorage des Kunden. Das ist bewusst so: ein
     Merkzettel gehoert niemandem ausser ihm, und ohne Konto gibt es keinen
     Ort, an dem wir ihn sinnvoll aufbewahren koennten. Auf der Seite steht
     deshalb auch, dass die Liste nur in diesem Browser existiert. */
  function readLater() {
    try {
      return JSON.parse(localStorage.getItem(LATER_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeLater(list) {
    try {
      localStorage.setItem(LATER_KEY, JSON.stringify(list));
    } catch (e) {
      /* Privater Modus oder volles Kontingent - dann bleibt die Liste leer. */
    }
  }

  function saveLater(entry) {
    var list = readLater().filter(function (x) { return String(x.id) !== String(entry.id); });
    list.unshift(entry);
    writeLater(list.slice(0, 30));
  }

  function dropLater(id) {
    writeLater(readLater().filter(function (x) { return String(x.id) !== String(id); }));
  }

  function paintLater() {
    var host = box();
    if (!host) return;
    var wrap = host.querySelector('[data-tnf-later-box]');
    var list = host.querySelector('[data-tnf-later-list]');
    if (!wrap || !list) return;

    var items = readLater();
    if (!items.length) {
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }

    wrap.hidden = false;
    list.innerHTML = '';
    items.forEach(function (entry) {
      var li = document.createElement('li');

      var name = document.createElement('span');
      name.textContent = entry.title || 'Artikel';
      li.appendChild(name);

      var acts = document.createElement('span');
      acts.style.display = 'flex';
      acts.style.gap = '8px';

      var back = document.createElement('button');
      back.type = 'button';
      back.setAttribute('data-tnf-later-back', entry.id);
      back.textContent = 'In den Warenkorb';
      acts.appendChild(back);

      var drop = document.createElement('button');
      drop.type = 'button';
      drop.setAttribute('data-tnf-later-drop', entry.id);
      drop.textContent = 'Löschen';
      acts.appendChild(drop);

      li.appendChild(acts);
      list.appendChild(li);
    });
  }

  paintLater();
})();
